export default __webpack_public_path__ + "6304948.png";